import React from 'react';
import { Box, Container, Typography, Grid, Avatar, Button, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const stats = [
  { value: '$550M+', label: 'Assets Under Management' },
  { value: '110', label: 'Portfolio Companies' },
  { value: '27', label: 'Profitable Exits' },
  { value: '20,000+', label: 'Members' },
];

const founders = [
  { name: 'Shelly Hod Moyal', role: 'Co-Founder & Managing Partner', avatar: 'https://ui-avatars.com/api/?name=Shelly+Hod+Moyal&size=200&background=0d9488&color=fff' },
  { name: 'Mor Assia', role: 'Co-Founder & Managing Partner', avatar: 'https://ui-avatars.com/api/?name=Mor+Assia&size=200&background=0d9488&color=fff' },
];

export default function AboutUs() {
  return (
    <Box>
      {/* Hero */}
      <Box sx={{ background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', color: '#fff', py: { xs: 8, md: 12 }, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h2" fontWeight={700} gutterBottom>We are iAngels</Typography>
          <Typography variant="h5" sx={{ opacity: 0.92, mb: 3, lineHeight: 1.6 }}>
            We are a team of entrepreneurs committed to transforming venture investing from an intuition-driven art to a data-driven science.
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.85 }}>
            We provide insider access to the best investment opportunities Israel's tech ecosystem has to offer.
          </Typography>
        </Container>
      </Box>

      {/* Stats */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Grid container spacing={4} justifyContent="center">
          {stats.map((s) => (
            <Grid item xs={6} md={3} key={s.label} sx={{ textAlign: 'center' }}>
              <Typography variant="h3" fontWeight={700} color="#0d9488">{s.value}</Typography>
              <Typography variant="body1" color="text.secondary">{s.label}</Typography>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Diversifying */}
      <Box sx={{ bgcolor: '#f8fffe', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="md" sx={{ textAlign: 'center' }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>Diversifying to Israeli Venture</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
            Founded in 2014 in Tel Aviv, Israel, iAngels bridges the gap between global investors and Israel's thriving tech ecosystem.
            Our data-driven approach, combined with deep local expertise, ensures our members gain access to the most promising startups before they hit the mainstream.
          </Typography>
        </Container>
      </Box>

      {/* Team */}
      <Container maxWidth="md" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>Our Founders</Typography>
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
          {founders.map((f) => (
            <Grid item xs={12} sm={6} key={f.name} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Avatar src={f.avatar} alt={f.name} sx={{ width: 140, height: 140, mb: 2 }} />
              <Typography variant="h6" fontWeight={600}>{f.name}</Typography>
              <Typography variant="body2" color="text.secondary">{f.role}</Typography>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Divider />

      {/* Contact */}
      <Container maxWidth="sm" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Typography variant="h5" fontWeight={600} gutterBottom>Get in Touch</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'center', mt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><LocationOnIcon sx={{ color: '#0d9488' }} /><Typography>Rothschild Blvd 18, Tel Aviv, Israel</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><PhoneIcon sx={{ color: '#0d9488' }} /><Typography>+972 3 901 3760</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><EmailIcon sx={{ color: '#0d9488' }} /><Typography>team@iangels.com</Typography></Box>
        </Box>
        <Button component={Link} to="/login" variant="contained" size="large" sx={{ mt: 4, bgcolor: '#0d9488', '&:hover': { bgcolor: '#0f766e' }, px: 5, py: 1.5, borderRadius: 2 }}>
          Join iAngels
        </Button>
      </Container>
    </Box>
  );
}
